import BigNumber from 'bignumber.js';
import store from '../store';
import Shops from '../api/shops';

export default class Upgrade {
    constructor(options) {
        this.name = '';
        this.id = '';
        this.idx = 0;
        this.type = 'shop';
        this.shop = null; //shop name or 'allShops'
        this.isApplied = false;
        this.localizedDescription = [];
        this.costs = 0.0;
        this.bonus = 0.0;
        this.bonusFactor = 0;
        this.bonusPercent = 0;
        this.shopID = 0;
        this.bonusType = 'decreaseProductionTime';
        this.description = null;
        this.icon = null;
        this.faClass = null;
        this.html = '';
        Object.assign(this, options);
    }

    /**
     * @param {string} type
     * @returns {Upgrade}
     */
    setBonusType(type) {
        this.bonusType = type;
        return this;
    }

    /**
     * @param {number} factor
     * @returns {Upgrade}
     */
    setBonusFactor(factor = 1) {
        this.bonusFactor = factor;
        return this;
    }

    generateDescription() {
        if (this.description !== null) {
            return this.description;
        }
        switch (this.bonusType) {
        case 'decreaseProductionTime':
            return 'UPGRADE_DECREASE_PRODUCTION_TIME';
        case 'increaseEarnings':
            return 'UPGRADE_INCREASE_EARNINGS';
        default:
            return '';
        }
    }

    setFAClass() {
        if (this.type === 'shop') {
            if (this.shop === 'all') {
                this.faClass = 'fa-money';
            } else {
                let shop = Shops.getShops(shops => shops.find(s => s.id === this.shop));
                this.faClass = typeof shop !== 'undefined' ? shop.faClass : null;
            }
        }
        return this;
    }

    setID(id) {
        this.id = id;
        return this;
    }

    setIDX(idx) {
        this.idx = idx;
        return this;
    }

    setCosts(costs) {
        this.costs = costs;
        return this;
    }

    setDescription(description) {
        this.description = description;
        return this;
    }

    getCostsByIndex(baseFactor, i, growth) {
        if (i <= 0) {
            return new BigNumber(baseFactor.toString())
                .times(Math.pow(i + 1, 2.0))
                .times(i + 1);
        }
        return new BigNumber(growth)
            .times(this.getCostsByIndex(baseFactor, i - 1, growth));
    }

    getCosts(upgradesByShopID) {
        let baseFactor = this.shop === 'all' || this.shopID === 0 ? 400000 : Math.pow(2, this.shopID + 1) * 8000,
            i          = 0,
            len        = upgradesByShopID.length,
            growth,
            found      = false;
        for (i; i < len; ++i) {
            if (this === upgradesByShopID[i]) {
                found = true;
                break;
            }
        }
        if (found === true) {
            growth = 10;//(this.shopID > 0) ? this.shopID * 1.19 : 10;
            return this.getCostsByIndex(baseFactor, i, growth);
        }
        console.error('Error: upgrade ', this, ' could not be found.');
        return new BigNumber('-1'); //this should never happen
    }

    isAffordable() {
        return this.costs.lte(store.getters.totalBalance);
    }

    /**
     * @param loaded
     */
    merge(loaded) {
        if (loaded.isApplied === true) {
            this.apply(true);
        }
    }

    apply(loaded = false) {
        let affectedShops = null,
            affectedShop  = null,
            applied       = false;
        loaded = typeof loaded === 'undefined' ? false : loaded;
        if (loaded && this.bonusType !== 'showTotalEarningsPerSecond' && this.bonusType !== 'showEarningsPerSecond') {
            this.isApplied = true;
            return this.isApplied;
        }
        if (this.shop !== null) {
            if (this.shop === 'all') {
                // does affect all shops
                affectedShops = store.getters.allShops;
            } else {
                affectedShop = store.getters.getShopByID(this.shop);
                if (affectedShop !== null && typeof affectedShop !== 'undefined') {
                    affectedShops = [affectedShop];
                }
            }
            if (affectedShops === null || affectedShops.length === 0) {
                console.error('No shop found for id ', this.shop);
                return false;
            }
        }
        switch (this.bonusType) {
        case 'decreasePrice':
            // decrease the build price by n percent
            if (affectedShops !== null && this.bonusPercent > 0) {
                affectedShops.forEach(shop => {
                    shop.costMultiplier -= shop.costMultiplier / (100 / this.bonusPercent);
                });
                applied = true;
            } else if (affectedShops !== null && this.bonusFactor > 0) {
                affectedShops.forEach(shop => {
                    shop.costMultiplier /= this.bonusFactor;
                });
                applied = true;
            }
            break;
        case 'increaseEarnings':
            if (affectedShops !== null && this.bonusFactor > 0) {
                affectedShops.forEach(shop => {
                    shop.setEarningsMultiplier(shop.earningsMultiplier * this.bonusFactor);
                });
                applied = true;
            }
            break;
        case 'decreaseProductionTime':
            if (affectedShops !== null && this.bonusFactor > 0) {
                affectedShops.forEach(shop => {
                    shop.coolDown /= this.bonusFactor;
                });
                applied = true;
            }
            break;
        case 'showEarningsPerSecond' :
            if (affectedShops !== null) {
                affectedShops.forEach(shop => {
                    shop.showEarningPerSecond = true;
                });
                applied = true;
            }
            break;
        case 'showTotalEarningsPerSecond' :
            store.commit('SHOW_TOTAL_INCOME_PER_SECOND');
            applied = true;
            break;
        default:
            break;
        }
        if (applied === false) {
            console.error('Error in upgradeFactory: cannot apply upgrade ', this);
            return false;
        }
        this.isApplied = true;
        if (loaded === false) {
            if (this.costs.lte(store.getters.totalBalance)) {
                store.commit('DECREASE_BALANCE', { amount: this.costs });
            } else {
                this.isApplied = false;
            }
        }
        return this.isApplied;
    }
}
